// extracted by mini-css-extract-plugin
module.exports = {"TextField":"TextField_TextField__2ikqY","Alt":"TextField_Alt__3B5t6","Inset":"TextField_Inset__33Vdm"};